// Root react component
import React, { Fragment } from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
// Components
import Dashboard from './dashboard/Dashboard';
import Navbar from './layouts/Navbar';
import HiPlot from './layouts/HiPlot';
import Footer from './layouts/Footer';
// UI
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
// Context
import ViewState from '../context/view/ViewState';
import GaugeState from '../context/gauge/GaugeState';
import AlertState from '../context/alerts/AlertState';

const App = () => {
	return (
		<Router>
			<Switch>
				<Route path="/hiplot/:index/:data">
					<HiPlot />
				</Route>
				<Route path="/">
					<GaugeState>
						<AlertState>
							<ViewState>
								<Fragment>
									<div id="myMm" style={{ height: "1mm" }} />
									<div id="page-content">
										<Container fluid style={{ paddingLeft: 0, paddingRight: 0 }}>
											<Row style={{ minHeight: '100vh', margin: 0 }}>
												<Navbar />
												<Dashboard />
												<Footer />
											</Row>
										</Container>
									</div>
								</Fragment>
							</ViewState>
						</AlertState>
					</GaugeState>
				</Route>
			</Switch>
		</Router>
	);
};

export default App;
